export enum StudentFiltersEnum {
  TOPPERS = "toppers",
  LAGARDS = "laggards",
  LEAST_PRACTICED = "leastEffort",
  MOST_EFFORT = "mostEffort",
}

export enum ChapterFiltersEnum {
  DEFAULT = "default",
  RECENT = "recent",
  IMPORTANT = "important",
  STRONGEST = "strongest",
  WEAKEST = "weakest",
}

export enum DashboardTabsEnum {
  REPORTS = "Reports",
  RECOMMENDATIONS = "Recommendations",
}

export enum BatchTestAnalysisTabsEnum {
  STUDENT_WISE_MARKS = "Student Wise Marks",
  PREFORMANCE_SUMMARY = "Performance Summary",
}

export enum StudentsProgressReportTabsEnum {
  CHAPTER_WISE_ANALYSIS = "Chapter Wise Analysis",
  INSTITUTE_TEST_REPORT = "Institute Test Report",
}

export enum PdfReportTypeEnum {
  MONTHLY_SCHOOL_REVIEW = "MonthlySchoolReview",
  MONTHLY_STUDENT_PROGRESS = "MonthlyStudentProgress",
  SCHOOL_TEST = "SchoolTest",
  STUDENT_TEST = "StudentTest",
  STUDENT_MARKSHEET = "StudentMarksheet",
}

export enum AffiliationReportTabEnum {
  STUDENT_WISE = "Student Wise",
  QUESTION_WISE = "Question Wise",
}

export enum StudentActivityTypeEnum {
  SELF_PRACTICE = 5,
  SELF_TEST = 6,
  INSTITUTE_TEST = 7,
  ASSIGNMENT = 8,
}

export enum SubjectiveQuestionSortTypeEnum {
  QUESTIONS = 1,
  STUDENTS = 2,
}

export enum SubjectiveEvaluationStatusEnum {
  PENDING = 1,
  AI_EVALUATED = 2,
  EVALUATED = 3,
}

// Batch-level release state for one activity's written answers — not to be confused with
// SubjectiveEvaluationStatusEnum above, which is the per-answer grading state. Grading publishes
// nothing: until a batch reaches FINALIZED every student still reads "Evaluation Pending" instead
// of a mark, and once it is there the state is terminal (there is no reopen endpoint).
export enum SubjectiveEvaluationFinalizationStatusEnum {
  PENDING = 1,
  FINALIZED = 2,
}

export enum ProgressStatusEnum {
  ON_SCHEDULE = "On Schedule",
  BEHIND_SCHEDULE = "Behind Schedule",
  AHEAD_OF_SCHEDULE = "Ahead of Schedule",
}

export enum OfflineActivityTabsEnum {
  STUDENT_WISE_OMRS = "OMR Review",
  TEST_MARKS_ENTRY = "Test Marks Entry",
}

// Sort options for the manual marks-entry list. DEFAULT keeps the original API order
// (no client-side sort); NAME / OVERALL are the keys the store sorts by.
export enum MarksEntrySortFieldEnum {
  DEFAULT = "Default",
  NAME = "Student",
  OVERALL = "TotalMarks",
}

// Sort fields for the affiliation activity report cards. The member NAME drives the
// pill label (via getCleanEnumName); the value is the row key the list sorts by — every
// value must exist on ActivityReportStudentRow / ActivityReportQuestionRow.
// Sort keys must be whole numbers or strings: sortNestedObjectArrayByField compares via
// localeCompare with `numeric: true`, which mis-orders fractions ("0.8" sorts before
// "0.45"). Hence the AccuracyPercent / AvgTimeSeconds integer companions.
export enum ActivityReportStudentSortFieldEnum {
  RANK = "RankSortKey",
  NAME = "StudentName",
  ACCURACY = "AccuracyPercent",
  TIME = "TotalTime",
}

export enum ActivityReportQuestionSortFieldEnum {
  HARDEST = "AccuracyPercent",
  PAPER_ORDER = "QuestionSerialNo",
  SLOWEST = "AvgTimeSeconds",
  ATTEMPTED = "TotalAttempted",
  CORRECT = "TotalCorrect",
  INCORRECT = "TotalIncorrect",
  SKIPPED = "TotalSkipped",
}

export enum AffiliationSelectorStateEnum {
  ENABLED = "Enabled",
  DISABLED = "Disabled",
  HIDDEN = "Hidden",
}

export enum InstituteTestCardActionEnum {
  EDIT = "Edit",
  QUESTIONS = "Questions",
  RENAME = "Rename",
  DELETE = "Delete",
  PREVIEW = "Preview",
  PUBLISH = "Publish",
  CLONE = "Clone",
  RESCHEDULE = "Reschedule",
  UNPUBLISH = "Unpublish",
  REPORT = "Report",
}

export enum AssignmentCardActionEnum {
  EDIT = "Edit",
  QUESTIONS = "Questions",
  RENAME = "Rename",
  DELETE = "Delete",
  PREVIEW = "Preview",
  PUBLISH = "Publish",
  CLONE = "Clone",
  RESCHEDULE = "Reschedule",
  REPORT = "Report",
}

export enum ActivityCardActionEnum {
  EDIT = "Edit",
  QUESTIONS = "Questions",
  RENAME = "Rename",
  DELETE = "Delete",
  PREVIEW = "Preview",
  DOWNLOAD = "Download",
  PUBLISH = "Publish",
  CLONE = "Clone",
  RESCHEDULE = "Reschedule",
  UNPUBLISH = "Unpublish",
  REPORT = "Report",
}

export enum ActivityAssetsTabsEnum {
  DOWNLOADS = "Downloads",
  INSTRUCTIONS = "Instructions",
}
